import type { App, Plugin } from "@pimo/pimo-app-builder";
import { canUserPerformOperation } from "product-test-utils";

import type { TestAppState } from "../app";
import { NotFoundPage } from "../components/not-found-page";
import { APP_ROUTES } from "../constants";

export class NotFoundPlugin implements Plugin<TestAppState> {
  onRegister(app: App<TestAppState>): void {
    const view = app.createView({ name: "NotFound" });
    const page = view.addComponent({ component: NotFoundPage });
    page.mapState(({ language, settings, userProfile }) => ({
      language,
      canViewPrograms: canUserPerformOperation({
        userGroups: userProfile?.groups || [],
        operation: "read",
        lowestLevelAccessRequiredToPerformThisOperation: "program",
        client: settings?.configuration?.client,
        tool: settings?.configuration?.tool,
      }),
    }));

    page.on("not-found:navigate", ({ payload }) => {
      if (payload?.path) app.navigate(payload.path);
    });
    // A page opened in a fresh tab has no history to go back to.
    page.on("not-found:back", () => {
      if (window.history.length > 1) window.history.back();
      else app.navigate(APP_ROUTES.home);
    });

    app.createRoute({ path: "*", view, isOverlayChild: false });
  }

  getName(): string {
    return "not-found-plugin";
  }
}
